import React from "react";
import { useTranslation } from "react-i18next";

import style from "./AnswerRespond.module.css";
import NextButton from "../nextButton/NextButton";

import Container from "@/layouts/container/Container";
import Icon from "@/ui/icon/Icon";

// Catalogue keys, not text: the message is looked up when it is shown.
const CORRECT_MESSAGES = [
	"quiz:answer.praise.exact",
	"quiz:answer.praise.bravo",
	"quiz:answer.praise.wellDone",
	"quiz:answer.praise.excellent",
	"quiz:answer.praise.great",
	"quiz:answer.praise.phenomenal",
	"quiz:answer.praise.super",
	"quiz:answer.praise.thatsIt",
	"quiz:answer.praise.goodJob",
];

function AnswerRespond({
	dispatch,
	index,
	questions,
	quiz,
	answer,
	isCorrectAnswer,
	correctAnswer,
}) {
	const { t } = useTranslation();

	return (
		<div
			className={`${style.answerRespond} ${
				isCorrectAnswer ? style.correct : style.wrong
			}`}
		>
			<Container size="medium">
				<div className={style.status}>
					<div className={style.icoHolder}>
						{isCorrectAnswer ? (
							<Icon icon="fa-badge-check" />
						) : (
							<Icon icon="fa-times" />
						)}
					</div>
					<div className={style.messageHolder}>
						<h4>
							{isCorrectAnswer
								? t(
										CORRECT_MESSAGES[
											Math.floor(
												Math.random() *
													CORRECT_MESSAGES.length
											)
										]
								  )
								: Math.random() == 0
								? t("quiz:answer.zero")
								: t("quiz:answer.wrong")}
						</h4>
						<p>
							{isCorrectAnswer ? (
								t("quiz:answer.right")
							) : (
								<>
									<span>{t("quiz:answer.correctAnswerIs")}</span>{" "}
									{correctAnswer}
								</>
							)}
						</p>
					</div>
				</div>
				<div className={style.nextButton}>
					<NextButton
						index={index}
						numQuestions={questions.length}
						dispatch={dispatch}
						quiz={quiz}
						answer={answer}
					/>
				</div>
			</Container>
		</div>
	);
}

export default AnswerRespond;
